import { Menu } from '@pocketlaw/tetris';
export function MenuMultiSelectItem(props) {
    const { disabled, selected = false, onClick, children, loading } = props;
    return (<Menu.ItemCheckbox checked={selected} disabled={disabled} loading={loading} onChange={onClick}>
      {children}
    </Menu.ItemCheckbox>);
}
